import en from './en.json';
import fr from './fr.json';
import rw from './rw.json';

export type TLocale = 'en' | 'fr' | 'rw';

export { en, fr, rw };

const dictionaries = {
  en,
  fr,
  rw,
};

export const getDictionary = (locale: TLocale): Record<string, string> => dictionaries[locale] as Record<string, string>;

export type TDictionary = Record<string, string>;
